// Rotas do backend consumidas pela SPA.
//
// Centralizadas aqui de propósito: manter os paths espalhados pelos
// componentes já causou 404 silencioso no login — se o prefixo mudar, mude aqui.
//
// A API do SPA é do Customer e vive sob /api (namespace Api:: no Rails) —
// fora do /admin, que pertence ao Devise do User (backoffice, telas ERB).
const ROUTES = {
  CUSTOMER_REQUEST_CODE: '/api/customers/request_code',
  CUSTOMER_SIGN_IN:      '/api/customers/sign_in',
  CUSTOMER_SIGN_OUT:     '/api/customers/sign_out',
  CUSTOMER_PURCHASE_PROCESSES: '/api/purchase_processes',
  CUSTOMER_PURCHASE_PROCESS_TIMELINE: (id) => `/api/purchase_processes/${id}/timeline`,
  CUSTOMER_PROCESS_DOCUMENT_UPLOAD: (id, documentKey) =>
    `/api/purchase_processes/${id}/documents/${documentKey}`,
  CUSTOMER_SESSION: '/api/session',
  GET_USERS: '/admin/users.json',
  THEME:     '/admin/theme.json',
  LOCALE:    '/admin/locale.json',
}

export default ROUTES;
